import React, { useState, useEffect, Fragment } from 'react';
import ReactDOM from 'react-dom';
import ReactPlayer from 'react-player';
import { component } from 'picoapp';
const str2json = require('../../utils/str2json');

function VideoCard({ parentNode }) {
  const [state, setState] = useState({
    mediaUrl: '',
    playing: false,
    showButton: false,
    showIcon: true
  })
  const { videoUrl, coverImage, tagline, options, buttonlabel, playInModal } = parentNode.dataset;
  const { showButton, showIcon, icon } = str2json(options);

  const playButton = parentNode.querySelector('.icon-play');

  useEffect(() => {

    setState({
      ...state,
      mediaUrl: videoUrl,
      coverImage: coverImage,
      tagline: tagline,
      showButton: showButton !== 'undefined' ? showButton : null,
      showIcon: showIcon !== 'undefined' ? showIcon : null,
      buttonLabel: buttonlabel ? buttonlabel : null,
      icon: icon ? icon : 'button-play',
      playInModal: playInModal
    })

  }, [])

  function toggle(e) {
    e.preventDefault();
    if (state.playing) {
      setState({ ...state, playing: !state.playing })
    } else {
      setState({ ...state, playing: true })
    }
  }

  return (
    <Fragment>

      <div className="details">
        <h3>{state.tagline && <span>{state.tagline}</span>}</h3>
        {state.showIcon && (
          <button
            type="button"
            className="Button Button--noLayout"
            onClick={!state.playInModal ? (e) => toggle(e) : null}
            data-action={state.playInModal ? "{ type: 'toggle', target: 'videoCardModal' }" : ""}>
            <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
              <use xlinkHref={`#${state.icon}`} />
            </svg>
          </button>
        )}
        {state.showButton &&
          (state.buttonLabel && (
            <button
              type="button"
              className="Button Button--noLayout"
              onClick={!state.playInModal ? (e) => toggle(e) : null}
              data-action={state.playInModal ? "{ type: 'toggle', target: 'videoCardModal' }" : ""}>
              <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                <use xlinkHref={`#${state.icon}`} />
              </svg>
              <span>{state.buttonLabel ? state.buttonLabel : 'Watch Now'}</span>
            </button>
          ))}
      </div>
      <div className="player-wrapper">
        {state.playInModal
          ? <img src={state.coverImage}
            data-action="{ type: 'toggle', target: 'videoCardModal' }"
            style={{ cursor: "pointer" }} loading="lazy" />
          : <ReactPlayer
            className="media-player"
            url={state.mediaUrl}
            playing={state.playing}
            width="100%"
            height="100%"
            onPause={toggle}
            onPlay={toggle}
            config={{
              youtube: {
                playerVars: {
                  modestbranding: 1,
                  showinfo: 0
                }
              }
            }}
          />
        }
      </div>
    </Fragment>
  );

}

export default component((node, ctx) => {
  const element = <VideoCard appstate={ctx} parentNode={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
